export default {
    User: "u",
    RoleTemplate: "ro",
    UserRole: "uro",
    Sheet: "sh",
    Dealer: "d",
    DealerOffice: "do",
    SheetReturnOnInvestment: "sroi",
    Client: "c",
    Service: "s",
    Defaults: "df",
    SheetType: "st",
    SheetAdmin: "sa",
    SheetFinance: "sf",
    Territory: "t",
    LargeFormat: "lf",
    SystemConfig: "cfg",
    MaintenancePeriodNotifications: "mpn",
    Invoice: "i",
    DefaultsRestrictions: "dfr",
    YieldBands: "yb",
    Rates: "ra",
    CFA: "cfa",
    UploadSettings: "ups",
    UploadSettingsTemplates: "ust",
    BoilerPlateTAndCs: "bptc",
    AdditionalManagedVolumeUnits: "amvu",
    SettlementConsideration: "sco",
    IntroductionPayment: "ip",
    UserMfa: "umfa",
    SPVs: "spv",
    Funder: "fu",
    ProductSchedule: "ps",
    PaperPrice: "pp",
    Agreements: "a",
    Schedules: "sc",
    Notifications: "n",
    Emails: "e",
    Paper: "pa",
    DocusignAdminRecipient: "dar",
    AdditionalDocuments: "ad",
    ReturnOnInvestment: "roi",
    ClientTemplate: "ct",
    SheetNote: "sn",
};
